import * as types from './types';
import moment from 'moment';
import _ from 'lodash';

const INITIAL_STATE = {
  error: undefined,
  fetching: false,
  fetchingUnclose: false,
  mealSummaries: [],
};
export default (state = INITIAL_STATE, action) => {
  const { payload } = action;

  switch (action.type) {
    case types.UNCLOSE_DAY_FETCHING:
      return { ...state, fetching: payload };

    case types.UNCLOSE_DAY_ERRORS:
      return { ...state, error: payload };

    case types.UNCLOSE_DAY_CLEAR_ERRORS:
      return { ...state, error: undefined };

    case types.UNCLOSE_DAY_FETCHING_UNCLOSE:
      return { ...state, fetchingUnclose: payload };

    case types.UNCLOSE_DAY_GET_DATA:
      let data = {
        ...state,
        mealSummaries: payload.map((x, i) => {
          return {
            ...x,
            ClosingDate: moment(x.ClosingDate).format('MM/DD/YYYY'),
            IsSelected: false,
            Id: i,
            MealType: x.MealType ? x.MealType : 'No summaries for this date',
          };
        }),
      };

      return data;

    case types.UNCLOSE_DAY_UPDATE_SELECTED:
      let newData = state.mealSummaries.slice();

      const found = _.find(newData, { Id: payload.Id });
      if (found === undefined) {
        return state;
      }
      found.IsSelected = !payload.IsSelected;

      return {
        ...state,
        mealSummaries: newData,
      };

    case types.UNCLOSE_DAY_CLEAR_SUMMARIES:
      return { ...state, mealSummaries: [] };

    case types.UNCLOSE_DAY_PROCESS:
      return { ...state, mealSummaries: [] };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/uncloseday/state/uncloseday/reducer.js